module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACESURBVHgBrZExEcNADATvhOAhBIINIQxCIRC+NIKUhmAKzyBhkEAIhG/t5iy5c2n7t9CMmp0diXDG9+sGYpLQ+ZpwEFIFYs734c+QCfieEe1RJdgbqPG6bOtMHjaZxAeaoc58VjSDKYQ/NEJQsRl4ok1lXcBsg7/apb0ftOAcEfMJR7hWieUpzvakkosAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/set2.png
// module id = eE89
// module chunks = 1